module.exports = __webpack_public_path__ + "static/media/21(1).c372165b.jpg";